import type { Reactive } from 'vue';
import type { DetailPageContext } from '#layers/block-engine';
import { reactiveComputed } from '@vueuse/core';
import { useBlockContext } from '#layers/block-engine';
import { blockContextIsDetailPage } from '~/utils/block';

export function useDetailPageContext(): Reactive<DetailPageContext & { isDetailPage: boolean }> {
	const { getRootContext } = useBlockContext();

	return reactiveComputed(() => {
		const rootContext = getRootContext();
		return {
			...rootContext as DetailPageContext,
			isDetailPage: blockContextIsDetailPage({ getRootContext }),
		};
	});
}
